import $ from 'jquery'
import {frame, unframe, redraw, isTouch} from '../utilities'

import Base from 'luminate/src/modules/base'

const $window = $(window)
let viewportHeight = $window.height()

$window.on('resize', e => viewportHeight = $window.height())

export default Base.extend({
	directive: 'parallax',

	defaults: {
		speed: 1,
		scale: false
	},

	events: {

		init: function()
		{
			// Disable for touch-screen devices
			if(isTouch()) return

			const $element = $(this.$element)
			const scale = this.$settings.scale
			const speed = Math.max(0, Math.min(parseFloat(this.$settings.speed), 1))

			let height
			let offset

			function setup()
			{
				$element.css('transform', '')
				$element.css('height', '')

				redraw($element)

				height = $element.outerHeight()
				offset = $element.offset()

				if(scale)
				{
					const viewHeight = Math.min(viewportHeight, offset.top + height)
					const newHeight = viewHeight - (viewHeight - height) * speed
					$element.css('height', newHeight + 'px')
				}

				position()
			}

			function position()
			{
				let translate = 0

				if(scale)
				{
					translate = ($window.scrollTop() - offset.top) * (speed - 1)
				}
				else
				{
					translate = ($window.scrollTop() - offset.top + (viewportHeight - height) / 2) * (speed - 1)
				}

				$element.css('transform', `translate3d(0, ${-translate}px, 0)`)
			}

			setup()

			let resizeId
			$(e => {
				unframe(resizeId)
				resizeId = frame(setup)
			})
			$window.on('load resize', e =>
			{
				unframe(resizeId)
				resizeId = frame(setup)
			})

			let scrollId
			$window.on('scroll', e =>
			{
				unframe(scrollId)
				resizeId = frame(position)
			})
		}
	}
})



// WEBPACK FOOTER //
// ./source/scripts/modules/parallax.js